import { INTEGRATIONS_ANIMATED_TEXTS } from '@modules/integrationsV2/components/IntegrationsHeader/constants';
import { Box, Fade, Slide, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const ANIMATION_DURATION = 2000;

export const AddNewIntegrationAnimatedText = () => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);

  useEffect(() => {
    const intervalTimer = setInterval(() => {
      setCurrentTextIndex(
        (index) => (index + 1) % INTEGRATIONS_ANIMATED_TEXTS.length,
      );
    }, ANIMATION_DURATION);

    return () => clearInterval(intervalTimer);
  }, []);

  return (
    <Box component="span" ml={0.45}>
      {INTEGRATIONS_ANIMATED_TEXTS.map(({ text, color }, index) => (
        <Slide
          appear={false}
          in={index === currentTextIndex}
          timeout={{ enter: 0, exit: 1000 }}
          style={{ position: 'absolute' }}
          key={`${text}${index}`}
        >
          <Box component="span">
            <Fade
              in={index === currentTextIndex}
              timeout={{ enter: 100, exit: 1000 }}
            >
              <Typography
                color={color}
                component="span"
                variant="subtitle2"
                fontWeight={600}
              >
                {text}
              </Typography>
            </Fade>
          </Box>
        </Slide>
      ))}
    </Box>
  );
};
